import { Component, OnInit } from '@angular/core';
import { ChartStockMA } from '../../../dto/ChartStockMA';
import { MarketAnalysisTickerService } from '../../../services/MarketAnalysisTickerService';
import { firstValueFrom } from 'rxjs';
import {
  CHART_COLORS, CHART_FONTS,
  CHART_STYLES,
} from '../../../../../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';
import Highcharts from 'highcharts';
/* eslint-disable */
@Component({
  selector: 'app-recovery-ticker-chart',
  templateUrl: './recovery-ticker-chart.component.html',
  styleUrls: ['./recovery-ticker-chart.component.scss'],
})
export class RecoveryTickerChartComponent implements OnInit {
  data: ChartStockMA[];
  // dataBySector: ChartStockMABySector[];
  chartTitle = 'EMCLOUD Enterprise value / revenue multiple';
  options: any;
  // optionsSecond: any;
  ChartYearsTabs = ChartYearsTabs;

  constructor(
    private analysisTickerService: MarketAnalysisTickerService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.setOptions();
    await this.initData();
  }

  async renderChartTicker(): Promise<void> {
    await this.initData();
  }

  async renderChartTickerFiltered(stocksNames: string[]): Promise<void> {
    await this.initFilterData(stocksNames);
  }

  async initData(): Promise<void> {
    this.data = await firstValueFrom(this.analysisTickerService.getChartMAData());
    this.configureXAxis();
    this.fillTheSeriesAndDrawChart(this.data);
  }

  async initFilterData(stocksNames: string[]): Promise<void> {
    this.data = await firstValueFrom(this.analysisTickerService.getFilteredChartMAData(stocksNames));
    this.configureXAxis();
    this.fillTheSeriesAndDrawChart(this.data);
  }

  onPeriodsNumberChange(selectedPeriods: string): void {
    switch (selectedPeriods) {
      case '1Y':
        this.setPeriod(1);
        break;
      case '3Y':
        this.setPeriod(3);
        break;
      default:
        this.setPeriod(10);
    }
  }

  private setPeriod(yearsBack: number): void {
    const now = new Date();
    const targetDate = new Date(now.setFullYear(now.getFullYear() - yearsBack)).getTime();
    const filteredData = this.data.filter((d) => Date.parse(d.period.toString()) >= targetDate);
    this.fillTheSeriesAndDrawChart(filteredData);
  }

  private fillTheSeriesAndDrawChart(data: ChartStockMA[]): void {
    this.options.series[0].data = data.map((d) => [Date.parse(d.period.toString()), d.medianRevenueIndex]);
    this.options.series[1].data = data.map((d) => [Date.parse(d.period.toString()), d.bottom25PercentMedian]);
    this.options.series[2].data = data.map((d) => [Date.parse(d.period.toString()), d.top25PercentMedian]);
    Highcharts.chart('marketAnalChartTicker', this.options);
  }

  private configureXAxis(): void {
    this.options.xAxis = [{
      type: 'datetime',
      labels: {
        formatter(): string {
          return Highcharts.dateFormat('%Y-%m', this.value);
        },
      },
    }];
  }

  // private setOptionsSecond(): void {
  //   this.optionsSecond = {
  //     chart: {
  //       type: 'line',
  //       height: 600,
  //     },
  //     title: {
  //       text: 'Revenue Index by Sector',
  //       align: 'left',
  //       style: CHART_STYLE_TICKER.tickerTitleStyle,
  //     },
  //     xAxis: {
  //       type: 'datetime',
  //       labels: {
  //         formatter() {
  //           return Highcharts.dateFormat('%Y-%m', this.value);
  //         },
  //       },
  //     },
  //     yAxis: {
  //       title: {
  //         enabled: false,
  //       },
  //       labels: CHART_STYLES.yAxisLabelsStyle,
  //     },
  //     series: [],
  //     credits: {
  //       enabled: false,
  //     },
  //   };
  // }

  // private configureChartSector() {
  //   const sectorSeriesMap = new Map<string, any>();
  //
  //   this.dataBySector.forEach((data) => {
  //     const period = Date.parse(data.period.toString());
  //
  //     data.sectorsRevenue.forEach((sectorRevenue: SectorRevenueDTO) => {
  //       if (!sectorSeriesMap.has(sectorRevenue.sector)) {
  //         sectorSeriesMap.set(sectorRevenue.sector, {
  //           name: sectorRevenue.sector,
  //           data: [],
  //         });
  //       }
  //       const series = sectorSeriesMap.get(sectorRevenue.sector);
  //       series.data.push([period, sectorRevenue.revenueIndex]);
  //     });
  //   });
  //
  //   sectorSeriesMap.forEach((series) => {
  //     series.data.sort((a, b) => a[0] - b[0]);
  //   });
  //
  //   this.optionsSecond.series = Array.from(sectorSeriesMap.values());
  //   Highcharts.chart('marketAnalChartTickerBySector', this.optionsSecond);
  // }

  private setOptions(): void {
    this.options = {
      chart: {
        type: 'line',
        height: 600,
      },
      title: {
        text: this.chartTitle,
        align: 'left',
        style: CHART_STYLE_TICKER.tickerTitleStyle,
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        floating: false,
        itemStyle: {
          color: CHART_COLORS.black12,
          cursor: 'pointer',
          fontSize: CHART_FONTS.font3,
          textOverflow: 'ellipsis',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
        },
        symbolWidth: 0,
        symbolHeight: 0,
        squareSymbol: false,
        labelFormatter(): string {
          const label = `<strong style="color:${this.color};
            transform: translateX(50%) !important; font-size: 1.25rem !important">• </strong>`;
          return label + this.name;
        },
      },
      navigation: CHART_STYLES.navigation,
      xAxis: [{
        labels: CHART_STYLES.xAxisLabelsStyle,
        categories: [],
        type: 'category',
        crosshair: true,
        scrollbar: CHART_STYLES.scrollbar,
        events: {
          // eslint-disable-next-line
          legendItemClick: function (event) { }
        },

      }],
      yAxis: [{
        title: {
          enabled: false,
        },
        labels: CHART_STYLES.yAxisLabelsStyle,
        stackLabels: CHART_STYLES.grandTotalStackLabels(),
      }],
      plotOptions: {
        column: {
          stacking: 'normal',
          width: 100,
          dataLabels: CHART_STYLES.dataLabels,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Median',
          yAxis: 0,
          color: CHART_COLORS.black12,
          data: [],
          showInLegend: true,
          zIndex: 3,
        },
        {
          name: 'Bottom Quartile',
          yAxis: 0,
          color: CHART_COLORS.orange,
          data: [],
          showInLegend: true,
        },
        {
          name: 'Top Quartile',
          yAxis: 0,
          color: CHART_COLORS.green,
          data: [],
          showInLegend: true,
        },
      ],
      lang: CHART_STYLES.lang,
    };
  }
}

export const ChartYearsTabs = ['1Y', '3Y', 'All'] as const;

const CHART_STYLE_TICKER = {
  tickerTitleStyle: {
    color: CHART_COLORS.black12,
    fontSize: CHART_FONTS.font2,
    fontWeight: 'bold',
    fontFamily: 'Inter, sans-serif',
  },
};
